import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';


import {HttpService} from '../../core/lib/http.service'
import { OthersService } from '../../services/others/others.service'
import { JsonPipe } from '@angular/common';
import { ICompanyData } from '@app/interfaces';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  @Output() messageEvent = new EventEmitter<any>();

  private apiurl:string;
  private defcompkey = "_defcompkey";
  private currentcompany = null;
  private mycompanies:any = [];
  private currentCompany:any = null;

  public uploadPercent = new Subject<string>();
  public currentUploadPercent = this.uploadPercent.pipe(
    shareReplay(1)
  );

  public setNewCompany = new BehaviorSubject<ICompanyData>(null)
  public currentSelectedCompany = this.setNewCompany.asObservable()

  public setCompanyId = new Subject<string>();
  public currentCompanyId = this.setCompanyId.pipe(
    shareReplay(1)
  );

  public setCardDetails = new BehaviorSubject<any>(null)
  public currentCardDetails$ = this.setCardDetails.asObservable()

  public setCtosPdf = new BehaviorSubject<any>({})
  public currentCtosPdf$ = this.setCtosPdf.asObservable()


  constructor(private httpservice:HttpService, private otherService:OthersService) { 
      this.apiurl = otherService.getApiUrl();
   
      //alert(this.apiurl);
  }

  onChangeCompany(company: ICompanyData) {
    this.setNewCompany.next(company)
  }

  onChangePathRoute(path: string) {
    console.log(path)
    localStorage.setItem('currentRoute', path)
  }

  setDefault(comp:any) {
    let json = JSON.stringify(comp);
    localStorage.setItem(this.defcompkey,json);
    this.otherService.setDefaultComp(comp);

    this.currentCompany = comp;
  }


  clearDefault() {
    localStorage.removeItem(this.defcompkey);
  }
  

  getCompany(id:string) {
     if (this.mycompanies &&this.mycompanies.length>0) {
      for(let x in this.mycompanies) {
        let comp:any = this.mycompanies[x];
        if (comp.id == id) {
            return comp;
        }
      }
    }

    return null;
  }

  public setDefList(complist:any) {
      this.mycompanies = complist;
  }

  async setList() {
  
  }

  setCardDetail(data: any) {
    this.setCardDetails.next(data)
  }


  getList() {
      return this.mycompanies;
  }


  getDault() {
      let json = localStorage.getItem(this.defcompkey);
      let def:any = this.otherService.getDefaultComp();
      
      if (json) {
         let obj = JSON.parse(json);
        
         this.currentCompany = obj;

         return JSON.parse(json);
      }

      return false;
  }


  getCurrentCompany() {
      return this.currentCompany ;
  }


  getRole() {
      if (this.currentCompany!=null)
        return this.currentCompany.role_id;
  }

  getTotalBrandCard(companyId: number, type: string) {
    return this.httpservice.get(`${this.apiurl}/v3/company/${companyId}/comcard/total?type=${type}`, {});
  }



  create(data:any) {
    
        return this.httpservice.post(this.apiurl + '/v3/company/create',data);   
  }


  update(id:string, data:any) {
      return this.httpservice.post(this.apiurl + '/v3/company/' + id,data);   
  }


  updateStatus(id:string, data:any) {
    return this.httpservice.post(this.apiurl + '/v3/admin/company/' + id + '/status',data);   
 }



  async gets(data) {
    try {

      console.log("API URL " + this.apiurl);
      return await this.httpservice.get(this.apiurl + '/v3/admin/company/list',data);
    }
    catch(err) {
      return false;
    }
  }


  async addSeats(id:string, data:any) {
    console.log("API URL " + this.apiurl);
    console.log('Update seat: ' + '/v3/admin/company/' + id + '/addSeats');
    return this.httpservice.post1(this.apiurl + '/v3/admin/company/' + id + '/addSeats',data);   
  }


  async get(id) {
      return await this.httpservice.get(this.apiurl + '/v3/company/' + id,{});
  }

  async getIndustry() {
    return await this.httpservice.get(this.apiurl + '/v3/company/industry',{});
}


  getCRole(id) {
    return this.httpservice.get2(this.apiurl + '/v3/company/' + id,{});
  }


  async getInfo(id) {
    return await this.httpservice.get(this.apiurl + '/v3/admin/company/' + id + '/info',{});
  }

  async getDepartments(id:string,data:any) {
    return await this.httpservice.get(this.apiurl + '/v3/company/' + id + '/department/list',data);
  }

  async getDepartmentsWithCount(id:string,data:any) {
    return await this.httpservice.get(this.apiurl + '/v3/company/' + id + '/department/listWithCount',data);
  }

  async checkRegno(regno:string) {
    return await this.httpservice.post1(this.apiurl + '/v3/company/verifyregno',{regno:regno});
  }

  ctosCheckRegno(regno:string, compname = '') {
    return this.httpservice.get2(this.apiurl + '/v3/ctos/company/info?regno='+regno+'&compname=""',{});
  }



  createDepartments(id:string,data:any) {
    return this.httpservice.post(this.apiurl + '/v3/company/' + id + '/department/create',data);
  }

  

  updateDepartment(id:string,did:string,data:any) {
    return this.httpservice.post(this.apiurl + '/v3/company/' + id + '/department/'+did,data);
  }

  async getComCards(id:string) {
    return this.httpservice.get(this.apiurl + '/v3/admin/company/' + id + '/comcard',{});
  }


  async getTotals(id:string) {
    return this.httpservice.get(this.apiurl + '/v3/admin/company/' + id + '/totals',{});
  }


  async searchComCards(id,keyword:string) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/comcard/search',{keyword:keyword});
  }

  async getNetworks(id:string,data:object) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/networks',data);
  }


  async getTotalNetworks(id:string,data) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/totalnetworks',data);
  }

  async getNonZero(id:string,data:object) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/nonzero',data);
  }

  getSeats(companyId: any) {
    console.log('123')
    return this.httpservice.get(`${this.apiurl}/v3/company/${companyId}/seats`, {})
  }

  async setHistory(compid, cat:string,action:string,sid,comcard,remark) {

    let data = {
      action:action,
      cat:cat,
      sid:sid,
      comcard:comcard,
      remark:remark
    }

    let rows = await this.sendHistory(compid,data);

    console.log("set History" + JSON.stringify(rows));

}

async sendHistory(id,data:object) {
  return await this.httpservice.post1(this.apiurl + '/v3/company/' + id + '/history',data);
}
}
